export const Bio = {
  name: "Hritik Ranjan",

  roles: [
    "Quality Assurance Engineer",
    "Software Test Engineer",
    "Manual & API Tester",
    "DevOps Enthusiast",
    "AWS & Cloud Learner",
    "Cybersecurity Enthusiast",
    "Open Source Contributor",
  ],

  description:
    "Quality Assurance Engineer with 1.8+ years of industry experience in Manual Testing, API Testing, Web Application Testing, Regression Testing, Sanity Testing, and Defect Management. Passionate about delivering high-quality software and continuously expanding my expertise in DevOps, Cloud, and Automation. Currently building hands-on projects with Linux, AWS, Docker, Git, Jenkins, Kubernetes, and CI/CD while exploring Cybersecurity and AI-powered technologies. Always eager to learn, build, and contribute to impactful products.",

  github: "https://github.com/hritikranjan1",

  resume:
    "https://drive.google.com/file/d/1VuyoBVH9FhGe-3Lr0I6BoJqq0kUFxj2m/view?usp=sharing",
  blog: "https://blogs.hritikranjan.in/",

  linkedin: "https://www.linkedin.com/in/hritik-ranjan-05a835230",

  twitter: "https://twitter.com/luvranjan143",

  telegram: "https://t.me/codewithluv143",

  discord: "https://discord.com/channels/@luvranjan",

  hashnode: "https://hashnode.com/@luvranjan143",
};

export const skills = [
  // ===================== Quality Assurance =====================
  {
    title: "Quality Assurance",
    skills: [
      {
        name: "Manual Testing",
        image: "https://img.icons8.com/color/96/test-passed.png",
      },
      {
        name: "Functional Testing",
        image: "https://img.icons8.com/color/96/inspection.png",
      },
      {
        name: "Regression Testing",
        image: "https://img.icons8.com/color/96/bug.png",
      },
      {
        name: "Smoke Testing",
        image: "https://img.icons8.com/color/96/task.png",
      },
      {
        name: "Sanity Testing",
        image: "https://img.icons8.com/color/96/checkmark.png",
      },
      {
        name: "API Testing (REST)",
        image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Postman",
        image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Test Case Design",
        image: "https://img.icons8.com/color/96/task.png",
      },
      {
        name: "Test Execution",
        image: "https://img.icons8.com/color/96/test-passed.png",
      },
      {
        name: "Bug Reporting",
        image: "https://img.icons8.com/color/96/bug.png",
      },
      {
        name: "Defect Lifecycle",
        image: "https://img.icons8.com/color/96/bug.png",
      },
      {
        name: "Jira",
        image: "https://cdn.worldvectorlogo.com/logos/jira-1.svg",
      },
      {
        name: "Zoho Projects",
        image: "https://cdn.worldvectorlogo.com/logos/zoho-1.svg",
      },
      {
        name: "Chrome DevTools",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/chrome/chrome-original.svg",
      },
    ],
  },

  // ===================== Test Automation =====================
  {
    title: "Test Automation",
    skills: [
      {
        name: "Playwright",
        image: "https://playwright.dev/img/playwright-logo.svg",
      },
      {
        name: "JavaScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "Git",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
      },
      {
        name: "VS Code",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      },
    ],
  },

  // ===================== DevOps & Cloud =====================
  {
    title: "DevOps & Cloud",
    skills: [
      {
        name: "Linux",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
      },
      {
        name: "AWS",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
      },
      {
        name: "Docker",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      },
      {
        name: "Kubernetes",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
      },
      {
        name: "Jenkins",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
      },
      {
        name: "Git",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
      },
      {
        name: "GitHub Actions",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
      },
      {
        name: "Bash",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg",
      },
      {
        name: "CI/CD",
        image: "https://img.icons8.com/color/96/infinity.png",
      },

    ],
  },

  // ===================== Programming Languages =====================
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Python",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
      {
        name: "JavaScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "Java",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      },
      {
        name: "C++",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
      },
      {
        name: "HTML5",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      },
      {
        name: "CSS3",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      },
    ],
  },

  // ===================== Development Tools =====================
  {
    title: "Development Tools",
    skills: [
      {
        name: "Git",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
      },
      {
        name: "VS Code",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      },
      {
        name: "Eclipse",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/eclipse/eclipse-original.svg",
      },
    ],
  },

  // ===================== Databases =====================
  {
    title: "Databases",
    skills: [
      {
        name: "PostgreSQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
      },
      {
        name: "Supabase",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/supabase/supabase-original.svg",
      },
    ],
  },

  // ===================== Frameworks & Libraries =====================
  {
    title: "Frameworks & Libraries",
    skills: [
      {
        name: "Flask",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg",
      },
      {
        name: "Scikit-learn",
        image: "https://github.com/hritikranjan1/Imagehosting/blob/main/scikit%20learn.jpg?raw=true",
      },
      {
        name: "TensorFlow",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg",
      },
      {
        name: "OpenCV",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opencv/opencv-original.svg",
      },
      {
        name: "Hugging Face",
        image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Hugging%20Face.png?raw=true",
      },
    ],
  },

  // ===================== Cybersecurity =====================
  {
    title: "Cybersecurity",
    skills: [
      {
        name: "Nmap",
        image: "https://nmap.org/images/nmap-logo-64px.svg",
      },
      {
        name: "Nessus",
        image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Nessus.png?raw=true",
      },
      {
        name: "PowerShell",
        image: "https://www.svgrepo.com/show/306596/powershell.svg",
      },
      {
        name: "Active Directory",
        image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Active%20Directory.png?raw=true",
      },
    ],
  },

  // ===================== Soft Skills =====================
  {
    title: "Soft Skills",
    skills: [
      {
        name: "Problem Solving",
        image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Problem%20Solving.jpeg?raw=true",
      },
      {
        name: "Critical Thinking",
        image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Critical%20Thinking.png?raw=true",
      },
      {
        name: "Communication",
        image: "https://img.icons8.com/color/96/communication.png",
      },
      {
        name: "Team Collaboration",
        image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Teamwork%20&%20Collaboration.jpeg?raw=true",
      },
      {
        name: "Time Management",
        image: "https://www.svgrepo.com/show/223883/time-management.svg",
      },
      {
        name: "Project Management",
        image: "https://www.svgrepo.com/show/138262/project-manager.svg",
      },
      {
        name: "Continuous Learning",
        image: "https://img.icons8.com/color/96/training.png",
      },
    ],
  },
];

 

export const experiences = [
  {
  id: 1,
  img: "https://github.com/hritikranjan1/Imagehosting/blob/main/esec.jpeg?raw=true",
  role: "Quality Assurance Engineer",
  company: "eSec Forte® Technologies, Gurugram, Haryana, India",
  date: "Sept 2025 – Present",
  desc: "Working as a Quality Assurance Engineer, focusing on ensuring software quality through manual and automated testing. Responsible for identifying bugs, validating functionalities, and improving product reliability. Collaborating with development teams to enhance performance, usability, and deployment processes while following QA best practices.",
  skills: [
    "Manual Testing",
    "Automation Testing",
    "Test Case Design",
    "Test Execution",
    "Bug Tracking",
    "Defect Reporting",
    "API Testing",
    "Postman",
    "Selenium",
    "Regression Testing",
    "Smoke Testing",
    "Functional Testing",
    "Agile Methodology",
    "SDLC",
    "STLC",
    "JIRA",
    "Git",
    "CI/CD Basics",
    "DevOps Fundamentals",
  ],
},
  {
    id: 0,
    img: "https://github.com/hritikranjan1/Imagehosting/blob/main/esec.jpeg?raw=true",
    role: "Information Security Intern",
    company: "eSec Forte® Technologies, Gurugram, Haryana",
    date: "Feb 2025 – Aug 2025",
    desc: "Gained hands-on experience in ethical hacking by working with virtual machines such as Metasploitable 2, Kioptrix, Sunset Lab, and Noontide. Used tools like Nmap, Nessus, and Burp Suite to perform network scanning, vulnerability assessments, and penetration testing. Identified security flaws, simulated real-world attacks, and practiced remediation techniques in a controlled lab environment.",
    skills: [
      "Ethical Hacking",
      "Metasploitable 2",
      "Kioptrix",
      "Sunset Lab",
      "Noontide",
      "Nmap",
      "Nessus",
      "Burp Suite",
      "Penetration Testing",
      "Vulnerability Assessment",
      "Security Flaw Remediation",
      "Virtual Machine Exploitation",
      "Network Scanning",
    ],
  },
  {
    id: 1,
    img: "https://github.com/hritikranjan1/Imagehosting/blob/main/compass.jpg?raw=true",
    role: "Cyber Security Intern",
    company: "Compass Group India, Gurgoan, Haryana",
    date: "June 2024 - Aug 2024",
    desc: "Identified and resolved system vulnerabilities by analyzing and implementing fixes. Worked extensively with Active Directory and PowerShell for automation and system management. Set up systems in autopilot mode for streamlined operations and improved efficiency.",
    skills: [
      "Vulnerability Assessment",
      "System Analysis and Fixes",
      "Active Directory Management",
      "PowerShell Scripting and Automation",
      "System Configuration and Management",
      "Nginx",
      "Autopilot System Setup",
      "Operational Efficiency Improvement",
      "RootShell",
      "Purple Knight",
    ],
  },
  {
    id: 2,
    img: "https://github.com/hritikranjan1/Imagehosting/blob/main/sunshil.jpeg?raw=true",
    role: "Robotics Mentor",
    company: "The Sanshil Foundation, Gurgoan, Haryana",
    date: "Dec 2023 - March 2024",
    desc: "Taught robotics to students, focusing on Arduino Uno and guided them in creating hands-on projects, including remote control cars, obstacle avoidance cars, Bluetooth-controlled cars, Wi-Fi-controlled cars, and digital door locks.",
    skills: [
      "C Programming",
      "Robotics Education",
      "IDE",
      "Arduino Uno Programming",
      "Hands-on Project Guidance",
      "Creative Problem-Solving",
      "Remote Control Systems",
    ],
  },
  {
    id: 3,
    img: "https://github.com/hritikranjan1/Imagehosting/blob/main/keen&able.jpeg?raw=true",
    role: "Python Datasets",
    company: "Keen & Able Computers Pvt Ltd, Noida",
    date: "June 2023 - July 2023",
    desc: "Utilized Python's JSON framework to create and manage multiple datasets for various applications, demonstrating strong skills in data manipulation and framework utilization.",
    skills: [
      "Python Programming",
      "JSON Data Manipulation",
      "Dataset Creation and Management",
      "Data Structure Design",
      "Data Analysis Techniques",
      "Framework Utilization",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://github.com/hritikranjan1/Imagehosting/blob/main/GITM.jpg?raw=true",
    school: "Global Institute of Technology And Management, Faruruknagar, Gurgoan",
    date: "Sept 2021 - Aug 2025",
    grade: "8 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Global Institute Of Technology and Management, Farruknagar. I have completed 6 semesters and have a CGPA of 8.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://github.com/hritikranjan1/Imagehosting/blob/main/bseh.jpeg?raw=true",
    school: "GSSS-Chakkarpur, Gurgoan",
    date: "Apr 2019 - Apr 2021",
    grade: "89.8%",
    desc: "I completed my class 12 high school education at Govt. Sr.Sec. School-Chakkarpur, Gurgoan, where I studied Science with Maths.",
    degree: "Senior secondary school(XII), Science with Maths",
  },
  {
    id: 2,
    img: "https://github.com/hritikranjan1/Imagehosting/blob/main/nios.png?raw=true",
    school: "DPS sec-45, Gurgoan",
    date: "Apr 2017 - Apr 2019",
    grade: "79.6%",
    desc: "I completed my class 10 education at Delhi Public School, Gurgoan, where I studied Basics Subjects and Data Entry.",
    degree: "Secondary school(X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "python-speech-recognition-game",
    date: "Jun 2024",
    description:
      "Create an interactive speech recognition game where users guess a word based on audio input. The game prompts users to speak their guesses, leveraging Google's speech recognition API to transcribe spoken words. Players have a limited number of attempts to guess the correct word, making it a fun way to test speech recognition capabilities and enjoy a guessing game.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/python%20speech.jpg?raw=true",
    tags: ["Python", "Speech Recognition", "Audio Processing", "Google API", "Interactive Game", "Voice Command", "Machine Learning", "Random Words"],
    category: "python project",
    github: "https://github.com/hritikranjan1/python-speech-recognition-game.git",
    webapp: "https://github.com/hritikranjan1/python-speech-recognition-game.git",
  },
  {
    id: 1,
    title: "Personality-Prediction-System",
    date: "Aug 2023",
    description:
      "Build a personality prediction system using logistic regression and resume parsing. The application allows users to input their details and upload a resume to predict their personality traits based on the Big Five personality model. It leverages machine learning for predictions and presents the results in a user-friendly Tkinter interface.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Personality-Prediction.jpg?raw=true",
    tags: ["Python", "Tkinter", "Machine Learning", "Logistic Regression", "Resume Parsing", "Data Science", "Big Five Personality", "Pandas", "NumPy", "Data Visualization"],
    category: "python project",
    github: "https://github.com/hritikranjan1/Personality-Prediction-System.git",
    webapp: "https://github.com/hritikranjan1/Personality-Prediction-System.git",
  },
  {
    id: 2,
    title: "Face-Recognition-AI-with-Python",
    date: "Sept 2024",
    description:
      "Develop a real-time face recognition system using OpenCV and face_recognition libraries. The application captures live video from the webcam, recognizes faces from a predefined set of images, and announces the identified individuals' names using text-to-speech. It provides a user-friendly interface for face identification and enhances accessibility.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Face-Recognition-Python.jpg?raw=true",
    tags: ["Python", "OpenCV", "Face Recognition", "Computer Vision", "Machine Learning", "Pyttsx3", "Real-time Processing", "Image Processing", "NumPy", "Speech Synthesis"],
    category: "artificial intelligence",
    github: "https://github.com/hritikranjan1/Face-Recognition-AI-with-Python.git",
    webapp: "https://github.com/hritikranjan1/Face-Recognition-AI-with-Python.git",
  },
  {
    id: 3,
    title: "Sale-price-prediction",
    date: "Sept 2023",
    description:
      "This project utilizes Linear Regression from the sklearn library to predict house prices based on features like living area, bathrooms, and bedrooms. It includes data preprocessing, model training, and performance evaluation using Mean Squared Error (MSE) and R-squared metrics.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/SAle%20price.png?raw=true",
    tags: ["Python", "Linear Regression", "Machine Learning", "Scikit-learn", "Housing Prices", "Data Science", "Model Evaluation", "Feature Selection"],
    category: "machine learning",
    github: "https://github.com/hritikranjan1/sale-price-prediction.git",
    webapp: "https://github.com/hritikranjan1/sale-price-prediction.git",
  },
  {
    id: 4,
    title: "Python-ai-assistant",
    date: "Dec 2023",
    description:
      "Create a voice assistant application that performs various tasks through voice commands. The program conducts initial checks for internet connectivity, clears the console, and displays an assistant logo before entering a continuous loop where it listens for and processes user commands. It utilizes modular components for improved functionality and easy maintenance.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Python-ai-assistant.PNG?raw=true",
    tags: ["Python", "Voice Assistant", "Speech Recognition", "Artificial Intelligence", "Modular Programming", "Command Line Interface", "Internet Connectivity", "Jarvis", "Automation"],
    category: "artificial intelligence",
    github: "https://github.com/hritikranjan1/-Python-ai-assistant.git",
    webapp: "https://github.com/hritikranjan1/-Python-ai-assistant.git",
  },
  {
    id: 5,
    title: "blindness-detection",
    date: "Dec 2023",
    description:
      "Implement an eye detection application using OpenCV and Haar cascades. The program loads an image, converts it to grayscale, and detects eyes within the image. If eyes are detected, it draws rectangles around them and displays the image, providing visual feedback on the detection results.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/AI-Blindness.png?raw=true",
    tags: ["Python", "OpenCV", "Computer Vision", "Eye Detection", "Haar Cascades", "Image Processing", "Machine Learning", "Visual Feedback"],
    category: "artificial intelligence",
    github: "https://github.com/hritikranjan1/blindness-detection.git",
    webapp: "https://github.com/hritikranjan1/blindness-detection.git",
  },
  {
    id: 6,
    title: "Message Encryption and Decryption Tool",
    date: "Apr 2024",
    description:
      "Create a user-friendly Tkinter application for message encryption and decryption. This program allows users to input a message, a key, and choose a mode (encrypt or decrypt). It utilizes a simple algorithm to encode and decode messages while providing an intuitive interface for users.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/MESSAGE%20ENCRYPTION.png?raw=true",
    tags: ["Python", "Tkinter", "GUI", "Encryption", "Decryption", "Base64", "Message Security", "Software Development", "User Interface"],
    category: "cyber security",
    github: "https://github.com/hritikranjan1/message-encryption-decryption.git",
    webapp: "https://message-encryption-decryption.onrender.com/",
  },
  {
  id: 7,
  title: "SteganoVault",
  date: "2025",
  description:
    "SteganoVault is a powerful steganography application that allows users to securely hide secret messages within various file types including images, text files, PDFs, DOCX documents, audio files, and videos. Built with Flask for the backend and modern HTML/CSS/JavaScript for the frontend, this tool provides a user-friendly interface for covert communication. Features include multi-format support, password protection, real-time processing, Google Drive integration, an interactive tutorial, stealth score system, responsive design, multiple themes, and robust security measures like OTP verification, password hashing, and CSRF protection.",
  image: "https://github.com/hritikranjan1/Imagehosting/blob/main/STEGANOVAULT.png?raw=true",
  tags: [
    "Python",
    "Flask",
    "HTML",
    "CSS",
    "JavaScript",
    "Steganography",
    "Supabase",
    "Google Drive API",
    "Security",
    "User Interface"
  ],
  category: "cyber security",
  github: "https://github.com/hritikranjan1/SteganoVault.git",
  webapp: "https://steganovault.onrender.com"
},
{
  id: 8,
  title: "Image Steganography App",
  date: "2025",
  description:
    "This project allows users to encode and decode secret messages within images using steganography techniques. It features an intuitive web interface to encode messages into images and decode hidden messages from images. Key features include message encoding, downloading encoded images, and message decoding. Built with Flask backend and uses image processing libraries along with HTML, CSS (Tailwind CSS), and JavaScript frontend.",
  image: "https://github.com/hritikranjan1/Imagehosting/blob/main/MSG%20ENCRYPTIONS%20&%20ECRYPTION.png?raw=true",
  tags: [
    "Python",
    "Flask",
    "HTML",
    "CSS",
    "JavaScript",
    "Steganography",
    "Image Processing",
    "Pillow",
    "User Interface"
  ],
  category: "cyber security",
  github: "https://github.com/hritikranjan1/image_steganography_app.git",
  webapp: "https://image-steganography-app-1.onrender.com"
},
{
    id: 9,
    title: "atm_interface_project",
    date: "Nov 2023",
    description:
      "Create a console-based ATM system in Java that allows users to register, log in, and perform basic banking operations. Users can withdraw, deposit, and transfer money, check their balance, and view transaction history, all while ensuring secure login with username and password authentication.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/atm_interface_project.jpg?raw=true",
    tags: ["Java", "ATM System", "Banking Application", "Console Application", "Object-Oriented Programming", "User Authentication", "Data Management", "Software Development"],
    category: "java project",
    github: "https://github.com/hritikranjan1/atm_interface_project.git",
    webapp: "https://github.com/hritikranjan1/atm_interface_project.git",
  },
  {
    id: 10,
    title: "number_guessing_game",
    date: "Nov 2023",
    description:
      "Develop a fun and interactive number guessing game in Java where players have up to 5 attempts to guess a randomly generated number between 1 and 100. The game provides hints to guess higher or lower, and awards points based on the number of attempts. Players can exit the game anytime by entering '0'.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/number_guessing_game.jpg?raw=true",
    tags: ["Java", "Number Guessing Game", "Random Number", "Console Application", "Game Development", "Loops", "User Interaction", "Programming Projects"],
    category: "java project",
    github: "https://github.com/hritikranjan1/number_guessing_game.git", // Fixed URL
    webapp: "https://github.com/hritikranjan1/number_guessing_game.git",
  },
  {
    id: 11,
    title: "online_examination_system",
    date: "Dec 2023",
    description:
      "Build an interactive Online Examination System in Java where users can log in or register and take a multiple-choice exam on programming languages such as C, C++, and Java. The system allows users to view their marks after the exam, with a question-answer format and logout functionality.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/online_examination_system%20.jpg?raw=true",
    tags: ["Java", "Online Examination System", "MCQ", "Console Application", "User Login", "Programming Quiz", "Educational App", "Java Projects"],
    category: "java project",
    github: "https://github.com/hritikranjan1/online_examination_system.git",
    webapp: "https://github.com/hritikranjan1/online_examination_system.git",
  },
  {
    id: 12,
    title: "Customer Segmentation with K-Means Clustering",
    date: "Sept 2023",
    description:
      "In this project, I explore customer behavior through data analysis and visualization. By utilizing K-Means clustering, I segment customers based on key metrics such as age, annual income, and spending score. The analysis includes comprehensive visualizations that highlight demographic trends and spending patterns, enabling businesses to tailor their marketing strategies effectively. This project showcases the power of data-driven insights in understanding consumer behavior, facilitating better decision-making for targeted marketing campaigns.",
    image: "https://github.com/hritikranjan1/Imagehosting/blob/main/Customer.png?raw=true",
    tags: ["Python", "Pandas", "Matplotlib", "Seaborn", "Scikit-learn", "KMeans", "Data Visualization", "Data Analysis", "Customer Segmentation"],
    category: "machine learning",
    github: "https://github.com/hritikranjan1/customer-segmentation.git",
    webapp: "https://github.com/hritikranjan1/customer-segmentation.git",
  },
];

export const TimeLineData = [
  { year: 2019, text: "Started exploring technology and coding" },
  { year: 2020, text: "Learned foundational programming languages" },
  { year: 2021, text: "Started my B.Tech in CSE and explored advanced AI techniques" },
  { year: 2022, text: "Interned in cybersecurity and enhanced my skills in automation" },
  { year: 2023, text: "Worked on major projects including AI-powered complaint management systems" },
  { year: 2024, text: "Collaborated on innovative AI, ML, and cybersecurity solutions" },
];